var WILLOW_SKIN_CONFIG = {};
  (function(){
    var node = document.querySelector('[data-willow-skin-config]');
    if(!node){ return; }
    try { WILLOW_SKIN_CONFIG = JSON.parse(node.textContent) || {}; } catch(e) {}
  })();

  (function(){
    var APP='.PRODUCT_PAGE-notify-button';

    /* One delegated handler covers app buttons that arrive after load without observing
       and rescanning the entire page for every Klaviyo/Judge/Shopify DOM mutation. */
    document.addEventListener('click', function(e){
      var target=e.target && e.target.nodeType===1 ? e.target : e.target && e.target.parentElement;
      var alertButton=target && target.closest ? target.closest('.product-form__alert') : null;
      if(!alertButton){ return; }
      var appButton=document.querySelector(APP);
      if(!appButton || appButton===alertButton){ return; }
      e.preventDefault();
      e.stopPropagation();
      appButton.click();
    }, true);

    /* Split sticky variant options after the native ProductStickyForm updates them.
       Bind to the exact product form; variant:change does not bubble in the base theme. */
    function splitStickyElement(el){
      var raw=(el.textContent||'').trim();
      if(raw.indexOf(' / ')===-1){ return; }
      var fragment=document.createDocumentFragment();
      raw.split(' / ').forEach(function(part){
        var span=document.createElement('span');
        span.className='wv-optline';
        span.textContent=part.trim();
        fragment.appendChild(span);
      });
      el.replaceChildren(fragment);
      el.setAttribute('data-wv-split',raw);
    }
    function bindSticky(sticky){
      if(sticky.__wvSplitBound){ return; }
      var el=sticky.querySelector('[data-sticky-product-options]');
      var formId=sticky.getAttribute('form');
      var form=formId && (document.forms[formId] || document.getElementById(formId));
      if(!el || !form){ return; }
      sticky.__wvSplitBound=true;
      splitStickyElement(el);
      form.addEventListener('variant:change', function(){
        var run=function(){ splitStickyElement(el); };
        if(typeof queueMicrotask==='function'){ queueMicrotask(run); }
        else { Promise.resolve().then(run); }
      });
    }
    function initStickySplits(){
      document.querySelectorAll('.product-sticky-form').forEach(bindSticky);
    }
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',initStickySplits,{once:true});
    }else{
      initStickySplits();
    }
    document.addEventListener('shopify:section:load',initStickySplits);
  })();
  document.body.classList.add('willow-pdp');
  if(WILLOW_SKIN_CONFIG.smallVanity){ document.body.classList.add('willow-vanity-sm'); }
  if(WILLOW_SKIN_CONFIG.soldOut){ document.body.classList.add('willow-soldout'); }
  if(WILLOW_SKIN_CONFIG.onSale){ document.body.classList.add('willow-on-sale'); }

  /* Mobile: shorten the long vanity title — drop the depth ("x 22 in. D") and "Bathroom Vanity"
     so e.g. "Aberdeen 24 in. W x 22 in. D Single Sink Bathroom Vanity" → "Aberdeen 24 in. W Single
     Sink". Walks TEXT NODES only (the theme renders the price inside the title, so we must not
     touch element nodes). Applies to the H1 and the sticky buy-bar title. */
  (function(){
    if(!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches){ return; }
    function shorten(t){
      return t
        .replace(/\s*[x×]\s*\d+\s*in\.?\s*D\b\.?/i, '')   /* " x 22 in. D" */
        .replace(/\s*Bathroom\s+Vanity\b/i, '')           /* " Bathroom Vanity" */
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+([,.])/g, '$1')
        .trim();
    }
    function run(root){
      if(!root){ return; }
      var w=document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while(n=w.nextNode()){
        var t=n.nodeValue;
        if(/in\.?\s*D|Bathroom\s+Vanity/i.test(t)){
          var s=shorten(t);
          if(s!==t){ n.nodeValue=s; }
        }
      }
    }
    /* Rolled back per request: show the FULL product title (no shortening). */
    function go(){ /* disabled — keep the full name */ }
    if(false){ go(); }
  })();

  (function(){
    var coll = WILLOW_SKIN_CONFIG.collection || '';
    var collUrl = WILLOW_SKIN_CONFIG.collectionUrl || '';
    var homeUrl = WILLOW_SKIN_CONFIG.homeUrl || '/';
    var prodTitle = WILLOW_SKIN_CONFIG.productTitle || '';
    var WSKU = WILLOW_SKIN_CONFIG.sku || '';
    var RATING = WILLOW_SKIN_CONFIG.rating || {};
    function placeRating(title){
      if(!RATING || !RATING.cnt || RATING.cnt < 1){ return; }
      if(document.querySelector('.product__info .willow-rating')){ return; }
      var a = document.createElement('a');
      a.className = 'willow-rating';
      a.href = '#judgeme_product_reviews';
      a.innerHTML = '<span class="willow-stars"><span class="willow-stars-bg">★★★★★</span><span class="willow-stars-fg" style="width:' + RATING.pct + '%">★★★★★</span></span>'
        + '<span class="willow-rating-num">' + RATING.avg + '</span>'
        + '<span class="willow-rating-cnt">' + RATING.cnt + ' review' + (RATING.cnt == 1 ? '' : 's') + '</span>';
      title.insertAdjacentElement('afterend', a);
    }
    function placeSku(rating, title){
      if(!WSKU){ return; }
      if(document.querySelector('.product__info .willow-sku')){ return; }
      var p = document.createElement('p');
      p.className = 'willow-sku';
      p.innerHTML = '<span class="willow-sku-k">SKU</span><span class="willow-sku-v">' + String(WSKU).replace(/[<>&]/g,'') + '</span>';
      var installment = document.querySelector('.product__info .installment');
      (installment || rating || title).insertAdjacentElement('afterend', p);
    }
    function syncSku(variant){
      if(!variant){ return; }
      var row = document.querySelector('.product__info .willow-sku');
      var value = row && row.querySelector('.willow-sku-v');
      if(!row || !value){ return; }
      WSKU = variant.sku || '';
      value.textContent = WSKU;
      row.hidden = !WSKU;
    }
    function bindSkuUpdates(){
      var info = document.querySelector('.product__info');
      var formId = info && info.getAttribute('form');
      var form = formId && (document.forms[formId] || document.getElementById(formId));
      if(!form || form.__wvSkuBound){ return; }
      form.__wvSkuBound = true;
      form.addEventListener('variant:change', function(event){
        syncSku(event.detail && event.detail.variant);
      });
    }
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', bindSkuUpdates, {once:true});
    }
    document.addEventListener('product-info:loaded', bindSkuUpdates);
    document.addEventListener('shopify:section:load', bindSkuUpdates);
    function removeSaleBadge(){
      document.querySelectorAll('.willow-sale-badge').forEach(function(b){ b.remove(); });
    }
    function placePrice(){
      // The theme renders the price beside the title (grid), which caps the title width.
      // Move it to its own row below the rating so the title spans the full block.
      var info = document.querySelector('.product__info'); if(!info){ return; }
      if(info.querySelector('.willow-price-row')){ return; }
      var price = info.querySelector('.product__title .product__price')
               || info.querySelector('.product__title [id^="Price-"]');
      if(!price){ return; }
      var anchor = info.querySelector('.willow-rating')
                || info.querySelector('.product__title');
      if(!anchor){ return; }
      price.classList.add('willow-price-row');
      anchor.insertAdjacentElement('afterend', price);
    }
    function watchPriceVisibility(){
      if(!('IntersectionObserver' in window)){ return; }
      var price = document.querySelector('.willow-price-row') || document.querySelector('.product__info .product__price');
      if(!price || price.__wvChatObserved){ return; }
      price.__wvChatObserved = true;
      var observer = new IntersectionObserver(function(entries){
        var visible = entries.some(function(entry){ return entry.isIntersecting; });
        document.body.classList.toggle('wv-price-visible', visible);
      }, { threshold: 0.15 });
      observer.observe(price);
    }
    function place(){
      var title = document.querySelector('.product__info .product__title') || document.querySelector('.product__title');
      if(!title){ return false; }
      placeRating(title);
      var rating = document.querySelector('.product__info .willow-rating');
      placeSku(rating, title);
      bindSkuUpdates();
      placePrice();
      removeSaleBadge();
      watchPriceVisibility();
      return true;
    }
    function finishPdpBoot(){
      window.__wvSkinReady=true;
      if(window.wvMaybeRevealPdp){ window.wvMaybeRevealPdp(); }
    }
    if(place()){
      finishPdpBoot();
    } else {
      var n = 0, iv = setInterval(function(){
        n++;
        if(place()){
          clearInterval(iv);
          finishPdpBoot();
        } else if(n > 40){
          clearInterval(iv);
          finishPdpBoot();
        }
      }, 50);
    }
  })();

  /* Keep the customer-facing PDP journey stable even if Shopify's JSON template
     temporarily falls behind the connected GitHub branch. This only moves existing
     section wrappers; it never clones or re-initializes section content. */
  (function(){
    var PDP_SECTION_ORDER = [
      'willow-assurance',
      'willow-materials',
      'scrolling-text',
      'willow-buying-guide',
      'judgeme-reviews',
      'willow-delivery-steps',
      'willow-qa',
      'faq',
      'product-recommendations',
      'recently-viewed'
    ];

    function findSection(key){
      return document.querySelector('[id^="shopify-section-"][id$="__' + key + '"]');
    }

    function enforcePdpSectionOrder(){
      if(!document.body || !document.body.classList.contains('template-product')){ return false; }

      var nodes = PDP_SECTION_ORDER.map(findSection).filter(Boolean);
      if(nodes.length < 2){ return false; }

      var parent = nodes[0].parentNode;
      if(!parent || !nodes.every(function(node){ return node.parentNode === parent; })){ return false; }

      var current = Array.prototype.filter.call(parent.children, function(node){
        return nodes.indexOf(node) !== -1;
      });
      var alreadyOrdered = current.length === nodes.length && current.every(function(node, index){
        return node === nodes[index];
      });

      if(!alreadyOrdered){
        var marker = document.createComment('willow-pdp-section-order');
        parent.insertBefore(marker, current[0] || nodes[0]);
        nodes.forEach(function(node){ parent.insertBefore(node, marker); });
        marker.parentNode.removeChild(marker);
      }

      var qualitySection = findSection('scrolling-text');
      if(qualitySection){
        var qualityStrong = qualitySection.querySelectorAll('strong');
        if(qualityStrong.length){
          qualityStrong.forEach(function(node){ node.textContent = 'Crafted from real wood. Never MDF.'; });
        }else{
          var qualityText = qualitySection.querySelector('p');
          if(qualityText){ qualityText.textContent = 'Crafted from real wood. Never MDF.'; }
        }
      }

      document.documentElement.setAttribute('data-willow-pdp-order', 'applied');
      return true;
    }

    function schedulePdpOrder(){
      [0, 120, 600, 1800].forEach(function(delay){
        setTimeout(enforcePdpSectionOrder, delay);
      });
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', schedulePdpOrder, { once: true });
    }else{
      schedulePdpOrder();
    }
    document.addEventListener('shopify:section:load', schedulePdpOrder);
  })();
